module.exports = __webpack_public_path__ + "media/images/icon_about6-d152b1f1891e96a9e0aece2b09feb52b.png";